// react imports
import React, { useState, useCallback } from 'react';
// project imports
import Calendar from 'src/common/refactoredComponents/calendar/Calendar/Calendar';
import CalendarPanel from './component/calendarPanel/Panel';
import OrdersCardView from './component/orders/ordersCardView/OrdersCardView';
import OrdersListView from './component/orders/ordersListView/OrdersListView';
import Timeline from 'src/common/components/timeline/Timeline';
import ActionsPanel from 'src/pages/home/component/actionsPanel';
import SearchBox from 'src/common/refactoredComponents/searchbox';
import Modal from 'src/common/components/modal';
import SearchResultsPanel from 'src/pages/home/component/orders/searchResultsPanel/SearchResultsPanel';
import OrdersSearchResults from 'src/pages/home/component/orders/ordersSearchResults/OrdersSearchResults';
import FilterResultsPanel from 'src/common/organisms/filterResultsPanel/components/FilterResultsPanelCalender.jsx';
import {
    getPreviousDate,
    addDaysToDate,
    isStartDateLessThanEndDate,
} from 'src/utils/dateUtils';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { getProxyList } from 'src/pages/more/pages/proxies/redux/action/index.js';

// External library imports
import styled from 'styled-components';
import media, { sizes } from 'src/styles/Media.styled';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { getCalendarSettings } from 'src/pages/more/redux/actions';
import {
    showDeleteOrderAction,
    showHideSummaryModal,
    deleteOrder,
    setOrderSummaryModalState,
    setOrderStatus,
    getOrderSummaryData,
} from 'src/pages/orders/redux/actions';
import { setCalendarView } from 'src/pages/home/redux/actions';
import {
    getViewData,
    getCardData,
    getSearchCardData,
    getListData,
    getAppliedFilters,
    setFilters,
    setSearchParam,
    getRefinedFilters,
    setViewDataEmpty,
    resetAppliedFilterUpdatedFlag,
    setShowFiltersResultsPanel,
} from 'src/pages/home/redux/actions';
import { getBannerDetails } from 'src/common/redux/actions';
import { convertDateToISOString, isMobileDevice } from 'src/utils/util';
import { getHolidayList } from '../scheduleSurgery/redux/actions';
import moment from 'moment';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { setActiveNavLink } from 'src/pages/home/redux/actions/index';
import DeleteOrderPopup from 'src/common/components/deleteOrderPopup/DeleteOrderPopup';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';
import NoUsageToReportContainer from 'src/pages/reportUsage/noUsageToReport';
import {
    RESET_CANCEL_USAGE_STATES,
    SET_SHOW_CONTACT_LOGISTICS_POPUP,
} from 'src/pages/reportUsage/redux/action/types';
import WarningModal from 'src/pages/reportUsage/common/warningModal';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

import {
    putFilterOptions,
    setSelectedCalendarView,
} from 'src/pages/home/redux/actions';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames } from 'src/constants/appConstants';

let isMobile = isMobileDevice();

const Home = (props) => {
    const summaryLoading = useSelector(
        (state) => state.orderSummaryReducer.loading
    );
    const deleteLoading = useSelector(
        (state) => state.deleteOrderReducer.loading
    );
    const orderCondition = useSelector(
        (state) => state.appliedFiltersReducer.displayOrderCondition
    );
    const calendarSettings = useSelector(
        (state) => state.getSettingsReducer.calendarSettings
    );
    const selectedDate = useSelector(
        (state) => state.filterReducer.selectedDate
    );
    const surgeryDates = useSelector(
        (state) => state.ordersReducer.viewData.surgeryDates
    );
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const calendarView = useSelector(
        (state) => state.filterReducer.calendarView
    );

    const visibleDateRange = useSelector(
        (state) => state.filterReducer.visibleDateRange,
        shallowEqual
    );
    const callOrderOrCalendar = useSelector(
        (state) => state.updateSurgeryReducer.callOrderOrCalendar
    );
    const isCalendarReload = useSelector(
        (state) => state.updateSurgeryReducer.isCalendarReload
    );

    useEffectWithErrorLogging(() => {
        const handleOrientationChange = () => {
            if (isMobileDevice()) {
                location.reload();
            }
        };

        window.addEventListener('orientationchange', handleOrientationChange);
        return () => {
            window.removeEventListener(
                'orientationchange',
                handleOrientationChange
            );
        };
    }, []);
    
    useEffectWithErrorLogging(() => {
        sessionStorage.removeItem('myCaseRefID');
        dispatch(getProxyList());
    }, []);

    const initiateProxyStatus = useSelector(
        (state) => state.InitiateProxyReducer.statusCode
    );
    // useEffectWithErrorLogging(() => {
    //     if (initiateProxyStatus === '200') {
    //         window.location.reload(true);
    //     }
    // }, [initiateProxyStatus]);
    const proxyTerminationStatus = useSelector(
        (state) => state.InitiateProxyReducer.terminationStatusCode
    );
    // useEffectWithErrorLogging(() => {
    //     if (proxyTerminationStatus === '200') {
    //         window.location.reload(true);
    //     }
    // }, [proxyTerminationStatus]);
    const userFilters = useSelector((state) => state.filterReducer.userFilters);

    const searchParam = useSelector((state) => state.filterReducer.searchParam);

    const appliedfiltersUpdated = useSelector(
        (state) => state.setfilterOptionsReducer.appliedfiltersUpdated
    );

    const [isModalVisible, setIsModalVisible] = useState(false);

    const displayFilters = useSelector(
        (state) => state.appliedFiltersReducer.displayFilters,
        shallowEqual
    );
    const displayOrderCondition = useSelector(
        (state) => state.appliedFiltersReducer.displayOrderCondition
    );

    const { isDeletePopup, deleteMyCaseRef, isOrderDetailsModal, isOtherUser } =
        useSelector((state) => state.deleteOrderReducer, shallowEqual);
    const deleteStatusCode = useSelector(
        (state) => state.deleteOrderReducer.statusCode
    );

    const searchCardData = useSelector(
        (state) => state.ordersReducer.searchCardData.orderData,
        shallowEqual
    );

    const { listViewStartDate, listViewEndDate } = useSelector(
        (state) => state.filterReducer
    );

    const calendarListStartDate = useSelector(
        (state) => state.filterReducer.userFilters.startDate
    );

    const calendarListEndDate = useSelector(
        (state) => state.filterReducer.userFilters.endDate
    );

    // No Usage To Report
    const showCancelSurgeryPopup = useSelector(
        (state) => state.noUsageToReportReducer.showCancelSurgeryPopup
    );
    const showCaseCancelOrPostpone = useSelector(
        (state) => state.noUsageToReportReducer.showCaseCancelOrPostpone
    );
    const showNoUsageToReportPopup = useSelector(
        (state) => state.noUsageToReportReducer.showNoUsageToReportPopup
    );
    const viewProcedureScreen = useSelector(
        (state) => state.noUsageToReportReducer.viewProcedureScreen
    );
    const cancelSurgeryData = useSelector(
        (state) => state.noUsageToReportReducer.cancelSurgeryData
    );
    const isCancelWithoutReason = useSelector(
        (state) => state.noUsageToReportReducer.isCancelWithoutReason
    );
    const cancelUsageInProgress = useSelector(
        (state) => state.noUsageToReportReducer.cancelUsageInProgress
    );
    const cancelUsageResponse = useSelector(
        (state) => state.noUsageToReportReducer.cancelUsageResponse
    );
    const isFromOrderDetailsModal = useSelector(
        (state) => state.noUsageToReportReducer.isFromOrderDetailsModal
    );
    const showContactLogisticsPopup = useSelector(
        (state) => state.noUsageToReportReducer.showContactLogisticsPopup
    );
    const showUnidPostponePopup = useSelector(
        (state) => state.noUsageToReportReducer.showUnidPostponePopup
    );
    const { updateSurgeryLoading } = useSelector((state) => ({
        updateSurgeryLoading: state.updateSurgeryReducer.updateSurgeryLoading,
    }));
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));

    const isImpersonationActive = useSelector(
        (state) => state.impersonationReducer.isImpersonationActive
    );

    const minSurgeryImpersonatedDate = useSelector(
        (state) =>
            state.impersonatedUserDataReducer.hybrisUserDetails.minSurgeryDate
    );
    const minSurgeryUserDate = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.minSurgeryDate
    );
    
    const appliedFilters = useSelector(
    (state) => state.appliedFiltersReducer,
    shallowEqual
   ); 

    const minSurgeryDate = isImpersonationActive
        ? minSurgeryImpersonatedDate
        : minSurgeryUserDate;

    const [OrderListStartDate, setOrderListStartDate] = useState(
        addDaysToDate(minSurgeryDate, 0)
    );

    useEffectWithErrorLogging(() => {
        setOrderListStartDate(addDaysToDate(minSurgeryDate, 0));
    }, [minSurgeryDate]);

    useEffectWithErrorLogging(() => {
        const cancelUsageMyCaseRef = cancelUsageResponse?.myCaseRef;
        if (
            isCancelWithoutReason &&
            cancelUsageResponse &&
            cancelUsageResponse.statusCode === '200'
        ) {
            if (isFromOrderDetailsModal && cancelUsageMyCaseRef) {
                dispatch(setOrderStatus({ orderStatus: '' }));
                dispatch(getOrderSummaryData());
                dispatch(
                    setOrderSummaryModalState({
                        myCaseRef: cancelUsageMyCaseRef,
                        orderSummaryModal: true,
                    })
                );
            }
            if (calendarView === 'Month' || calendarView === 'Week') {
                dispatch(getCardData({ ...userFilters }));
            } else if (calendarView === 'List') {
                dispatch(getListData({ ...userFilters }));
            }
            dispatch({ type: RESET_CANCEL_USAGE_STATES });
        }
        if (isCalendarReload) {
            if (calendarView === 'Month' || calendarView === 'Week') {
                dispatch(getCardData({ ...userFilters }));
            } else if (calendarView === 'List') {
                dispatch(getListData({ ...userFilters }));
            }
        }
    }, [isCancelWithoutReason, cancelUsageResponse, callOrderOrCalendar]);

    useEffectWithErrorLogging(() => {
        localStorage.setItem('pageName', `Calendar-${calendarView}-View`);
    }, []);

    useEffectWithErrorLogging(() => {
        if (userFilters.resourceType !== 'VIEW_DATA')
            dispatch(
                getSearchCardData({ searchParam: userFilters.searchParam })
            );
    }, [searchParam]);

    const selectedViewFilter = useSelector(
        (state) => state.filterReducer.userFilters.filterParam
    );

    const defaultCalendarViewId = useSelector(
        (state) => state.appliedFiltersReducer.defaultCalendarViewId
    );

    const searchCardDataLoading = useSelector(
        (state) => state.ordersReducer.searchCardDataLoading
    );

    const settingsLoading = useSelector(
        (state) => state.getSettingsReducer.loading
    );
    const token = localStorage.getItem('authToken');

    useEffectWithErrorLogging(() => {
        dispatch(getCalendarSettings());
        // dispatch(getBannerDetails());
        dispatch(
            setActiveNavLink({
                dashboard: false,
                calendar: true,
                admin: false,
                orders: false,
                alerts: false,
                inventory: false,
                more: false,
                deniedUsageOverrides: false,
                productGuide: false,
            })
        );
        return () => {
            dispatch(resetAppliedFilterUpdatedFlag());
            dispatch(showHideSummaryModal({orderSummaryModal: false,}));
        };
    }, []);

    useEffectWithErrorLogging(() => {
        let yesterday = moment(new Date()).subtract(1, 'days').toDate();
        //console.log('🚀 : yesterday', yesterday);
        let numberOfPastDaysForWhichHolidaysToBeFetched = 30;
        let arrayOfLastThirtyDays = [
            ...Array(numberOfPastDaysForWhichHolidaysToBeFetched),
        ].map((date, index) =>
            convertDateToISOString(
                moment(yesterday)
                    .startOf('day')
                    .subtract(index, 'days')
                    .toDate(),
                'start'
            )
        );

        //console.log(arrayOfLastThirtyDays);
        dispatch(
            getHolidayList({
                date: arrayOfLastThirtyDays,
                calculateLastThreeBusinessDays: true,
            })
        );
    }, [callOrderOrCalendar]);

    useEffectWithErrorLogging(() => {        
            dispatch(
                getAppliedFilters({
                fields: 'DEFAULT',
                filterParam: selectedViewFilter
                    ? selectedViewFilter
                    : defaultCalendarViewId,
                })
            );           
    }, [token]);

    //On Mount call the view data till the end of the current month irrespective of mobile or desktop
    useEffectWithErrorLogging(
        useCallback(() => {
            if (!visibleDateRange[0] || !visibleDateRange[1]) return;
            fetchInitialSurgeryDates();
        }),
        [callOrderOrCalendar]
    );

    useEffectWithErrorLogging(
        useCallback(() => {
            fetchExtraSurgeryDates();
        }),
        [visibleDateRange, calendarView, callOrderOrCalendar]
    );

    useEffectWithErrorLogging(() => {
        if (appliedfiltersUpdated) {
            dispatch(
                getAppliedFilters({
                    fields: 'DEFAULT',
                    filterParam: selectedViewFilter
                        ? selectedViewFilter
                        : defaultCalendarViewId,
                })
            );
            fetchSurgeryDatesWhenFiltersUpdated();
            if (calendarView === 'Month' || calendarView === 'Week') {
                dispatch(
                    getCardData({
                        ...userFilters,
                    })
                );
            }
            if (calendarView === 'List') {
                dispatch(
                    getListData({
                        ...userFilters,
                        startDate: convertDateToISOString(
                            OrderListStartDate,
                            'start'
                        ),
                    })
                );
            }
        }
    }, [appliedfiltersUpdated]);

    useEffectWithErrorLogging(() => {
        if (
            deleteStatusCode &&
            deleteStatusCode !== '' &&
            deleteStatusCode === '10707'
        ) {
            if (calendarView === 'Month' || calendarView === 'Week') {
                dispatch(
                    getCardData({
                        ...userFilters,
                    })
                );
            }
            if (calendarView === 'List') {
                dispatch(
                    getListData({
                        ...userFilters,
                        startDate: convertDateToISOString(
                            OrderListStartDate,
                            'start'
                        ),
                    })
                );
            }
            if (searchParam !== '' && searchParam) {
                dispatch(setSearchParam(searchParam));
                dispatch(
                    getSearchCardData({
                        searchParam: searchParam,
                    })
                );
                openModal(true);
            }
        }
    }, [deleteStatusCode]);

    const deleteOrderHandler = () => {
        dispatch(deleteOrder(deleteMyCaseRef));
        dispatch(
            showDeleteOrderAction({
                isDeletePopup: false,
            })
        );
    };

    const deleteCloseHandler = () => {
        dispatch(
            showDeleteOrderAction({
                isDeletePopup: false,
                deleteMyCaseRef: '',
                isOtherUser: false,
            })
        );
        if (isOrderDetailsModal) {
            dispatch(
                showHideSummaryModal({
                    orderSummaryModal: true,
                })
            );
        }
    };
    useEffectWithErrorLogging(() => {
        let param = selectedViewFilter
            ? selectedViewFilter
            : defaultCalendarViewId;
        if (param) {
            dispatch(
                getRefinedFilters({
                    filterParam: selectedViewFilter
                        ? selectedViewFilter
                        : defaultCalendarViewId,
                })
            );
        }

        // dispatch(getPageVisibilityRule({ fields: 'BASIC' }));
    }, [defaultCalendarViewId]);

    useEffectWithErrorLogging(() => {
        let param = selectedViewFilter
            ? selectedViewFilter
            : defaultCalendarViewId;

        if (!param) return;
        dispatch(
            setFilters({
                filterParam: param,
            })
        );
    }, [defaultCalendarViewId]);

    const fetchInitialSurgeryDates = () => {
        let startDate, endDate;
        let endDateOfNextMonth = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() + 2,
            0
        );
        let firstDateOfPreviousMonth = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() - 1,
            1
        );
        startDate = convertDateToISOString(firstDateOfPreviousMonth, 'start');
        endDate = convertDateToISOString(endDateOfNextMonth, 'end');
        let startDate1 = convertDateToISOString(getPreviousDate(new Date(), 365),'start');
        let endDate1 = convertDateToISOString(firstDateOfPreviousMonth, 'end');
        if(startDate1 < startDate){
            startDate = startDate1;
        }
        if(endDate1 > endDate1){
            endDate = endDate1;
        }
        dispatch(setViewDataEmpty());
        isStartDateLessThanEndDate(startDate, endDate) &&
            dispatch(
                getViewData({
                    ...userFilters,
                    startDate: startDate,
                    endDate: endDate,
                    sortOrder: 'ASC',
                    //  pageNum: 0,
                    //  pageLimit: 0,
                    sortParam: 'surgeryStartDate',
                })
            );
        // startDate = convertDateToISOString(
        //     getPreviousDate(new Date(), 365),
        //     'start'
        // );
        // endDate = convertDateToISOString(firstDateOfPreviousMonth, 'end');
        // isStartDateLessThanEndDate(startDate, endDate) &&
        //     dispatch(
        //         getViewData({
        //             ...userFilters,
        //             startDate: startDate,
        //             endDate: endDate,
        //             sortOrder: 'ASC',
        //             //    pageNum: 0,
        //             //    pageLimit: 0,
        //             sortParam: 'surgeryStartDate',
        //         })
        //     );
    };

    useEffectWithErrorLogging(() => {
        if (localStorage.getItem('lastSelDLPCalView')) return;
        if (
            window.innerWidth >= sizes.smalDevice &&
            calendarSettings?.defaultView
        ) {
            dispatch(
                setCalendarView(
                    calendarSettings?.defaultView === 'month'
                        ? 'Month'
                        : calendarSettings?.defaultView === 'agendaWeek'
                        ? 'Week'
                        : 'List'
                )
            );
        }
    }, [calendarSettings]);

    const fetchExtraSurgeryDates = () => {
        let startDate, endDate;
        let firstSurgeryDate = new Date(surgeryDates[0]);
        firstSurgeryDate?.setHours(0, 0, 0, 0);
        let lastSurgeryDate = new Date(surgeryDates[surgeryDates.length - 1]);
        lastSurgeryDate?.setHours(0, 0, 0, 0);

        if (
            visibleDateRange[0].setHours(0, 0, 0, 0) <=
            firstSurgeryDate?.setHours(0, 0, 0, 0)
        ) {
            startDate = convertDateToISOString(
                getPreviousDate(new Date(), 365),
                'start'
            );
            endDate = convertDateToISOString(firstSurgeryDate, 'end');
            isStartDateLessThanEndDate(startDate, endDate) &&
                dispatch(
                    getViewData({
                        ...userFilters,
                        startDate: startDate,
                        endDate: endDate,
                        sortOrder: 'ASC',
                        //    pageNum: 0,
                        //    pageLimit: 0,
                        sortParam: 'surgeryStartDate',
                    })
                );
        }
        if (
            visibleDateRange[1].setHours(0, 0, 0, 0) >=
            lastSurgeryDate?.setHours(0, 0, 0, 0)
        ) {
            let firstDateOfCurrentMonth = new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth(),
                1
            );
            let endDateOfNextToNextMonth = new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth() + 3,
                0
            );
            startDate = convertDateToISOString(
                firstDateOfCurrentMonth,
                'start'
            );
            endDate = convertDateToISOString(endDateOfNextToNextMonth, 'end');
            isStartDateLessThanEndDate(startDate, endDate) &&
                dispatch(
                    getViewData({
                        ...userFilters,
                        startDate: startDate,
                        endDate: endDate,
                        sortOrder: 'ASC',
                        //    pageNum: 0,
                        //    pageLimit: 0,
                        sortParam: 'surgeryStartDate',
                    })
                );
        }
    };

    const fetchSurgeryDatesWhenFiltersUpdated = () => {
        let startDate, endDate;
        //if user is in past month
        if (
            !(
                visibleDateRange[0]?.getTime() <=
                    new Date().setHours(0, 0, 0, 0) &&
                visibleDateRange[1]?.getTime() >=
                    new Date().setHours(0, 0, 0, 0)
            ) &&
            new Date(selectedDate).getTime() <= new Date().setHours(0, 0, 0, 0)
        ) {
            let firstDateOfMonthOneYearFromToday = new Date(
                getPreviousDate(selectedDate, 365).getFullYear(),
                getPreviousDate(selectedDate, 365).getMonth(),
                1
            );
            let endDateOfNextMonth = new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth() + 2,
                0
            );
            let firstDateOfPreviousMonth = new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth() - 1,
                1
            );
            dispatch(setViewDataEmpty());
            //if user is within 3 months from a date one year from today
            if (
                firstDateOfPreviousMonth.getTime() >=
                    firstDateOfMonthOneYearFromToday.getTime() &&
                endDateOfNextMonth.getTime() <= firstDateOfMonthOneYearFromToday
            ) {
                startDate = convertDateToISOString(
                    firstDateOfMonthOneYearFromToday,
                    'start'
                );
                endDate = convertDateToISOString(
                    addDaysToDate(firstDateOfMonthOneYearFromToday, 90),
                    'end'
                );
                isStartDateLessThanEndDate(startDate, endDate) &&
                    dispatch(
                        getViewData({
                            ...userFilters,
                            startDate: startDate,
                            endDate: endDate,
                            sortOrder: 'ASC',
                            //    pageNum: 0,
                            //    pageLimit: 0,
                            sortParam: 'surgeryStartDate',
                        })
                    );
                startDate = convertDateToISOString(
                    addDaysToDate(firstDateOfMonthOneYearFromToday, 90),
                    'start'
                );
                endDate = convertDateToISOString(new Date(), 'end');
                isStartDateLessThanEndDate(startDate, endDate) &&
                    dispatch(
                        getViewData({
                            ...userFilters,
                            startDate: startDate,
                            endDate: endDate,
                            sortOrder: 'ASC',
                            //    pageNum: 0,
                            //    pageLimit: 0,
                            sortParam: 'surgeryStartDate',
                        })
                    );
            } else {
                startDate = convertDateToISOString(
                    firstDateOfPreviousMonth,
                    'start'
                );
                endDate = convertDateToISOString(endDateOfNextMonth, 'end');
                isStartDateLessThanEndDate(startDate, endDate) &&
                    dispatch(
                        getViewData({
                            ...userFilters,
                            startDate: startDate,
                            endDate: endDate,
                            sortOrder: 'ASC',
                            //    pageNum: 0,
                            //    pageLimit: 0,
                            sortParam: 'surgeryStartDate',
                        })
                    );
                startDate = convertDateToISOString(endDateOfNextMonth, 'start');
                endDate = convertDateToISOString(new Date(), 'end');
                isStartDateLessThanEndDate(startDate, endDate) &&
                    dispatch(
                        getViewData({
                            ...userFilters,
                            startDate: startDate,
                            endDate: endDate,
                            sortOrder: 'ASC',
                            //    pageNum: 0,
                            //    pageLimit: 0,
                            sortParam: 'surgeryStartDate',
                        })
                    );
                startDate = convertDateToISOString(
                    getPreviousDate(new Date(), 365),
                    'start'
                );
                endDate = convertDateToISOString(
                    firstDateOfPreviousMonth,
                    'end'
                );
                isStartDateLessThanEndDate(startDate, endDate) &&
                    dispatch(
                        getViewData({
                            ...userFilters,
                            startDate: startDate,
                            endDate: endDate,
                            sortOrder: 'ASC',
                            //    pageNum: 0,
                            //    pageLimit: 0,
                            sortParam: 'surgeryStartDate',
                        })
                    );
            }
        }
        //if user is in a future month
        else if (
            !(
                visibleDateRange[0]?.getTime() <=
                    new Date().setHours(0, 0, 0, 0) &&
                visibleDateRange[1]?.getTime() >=
                    new Date().setHours(0, 0, 0, 0)
            ) &&
            new Date(selectedDate).getTime() >= new Date().setHours(0, 0, 0, 0)
        ) {
            let currentMonthEndDate = new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth() + 1,
                0
            );
            startDate = convertDateToISOString(
                getPreviousDate(currentMonthEndDate, 364),
                'start'
            );
            endDate = convertDateToISOString(currentMonthEndDate, 'end');
            isStartDateLessThanEndDate(startDate, endDate) &&
                dispatch(setViewDataEmpty());
            dispatch(
                getViewData({
                    ...userFilters,
                    startDate: startDate,
                    endDate: endDate,
                    sortOrder: 'ASC',
                    // pageNum: 0,
                    // pageLimit: 0,
                    sortParam: 'surgeryStartDate',
                })
            );
        }
        //if user is in current month
        else {
            fetchInitialSurgeryDates();
        }
    };

    const closeModal = () => {
        let body = document.getElementById('body');
        body.style.overflow = '';
        const calendarWrapper = document.getElementsByClassName('calender-wrapper')?.[0];
        if (calendarWrapper) {
            calendarWrapper.style.display = '';
        }
        setIsModalVisible(!isModalVisible);
        dispatch(setSearchParam(''));

        // dispatch(
        //     getCardData({
        //         ...userFilters,
        //         searchParam: '',
        //     })
        // );
    };

    const openModal = (fromSearch) => {
        if (window.innerWidth > sizes.mobileDevice) {
            let body = document.getElementById('body');
            body.style.overflow = 'hidden';
        }
        if (fromSearch) {
            setIsModalVisible(true);
        } else if (searchParam != '' && searchParam) {
            setIsModalVisible(true);
        }
    };
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    const [modalWidth, setModalWidth] = useState('calc(100% - 122px)');
    const [modalHeight, setModalHeight] = useState('calc(100% - 46px)');
    window.onresize = () => {
        setInnerWidth(window.innerWidth);
        if (isModalVisible) {
            if (window.innerWidth > sizes.mobileDevice) {
                let body = document.getElementById('body');
                body.style.overflow = 'hidden';
            } else {
                let body = document.getElementById('body');
                body.style.overflow = '';
            }
        }
    };

    /*
    Gettting banner message length so that body style override can be prevented till the confirmation dialog
     is dismissed
    */
    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );

    useEffectWithErrorLogging(() => {
        const isConfirmation =
            (bannerInfo || []).filter(
                (item) => item.messageType === 'userConfirmMessage'
            ).length > 0;
        if (!isConfirmation) {
            let body = document.getElementById('body');
            body.style.overflow = '';
            if (
                window.innerWidth > sizes.smalDevice &&
                window.innerHeight < sizes.mobileDevice
            ) {
                //mobile device
                setModalWidth('calc(100% - 40px)');
                setModalHeight('calc(100% - 50px)');
            } else if (window.innerWidth === sizes.smalDevice) {
                //for Ipad potrait mode
                body.style.overflow = 'hidden';
                setModalWidth('calc(100% - 38px)');
                setModalHeight('calc(100% - 55px)');
            } else if (window.innerWidth === sizes.mediumDevice) {
                //for Ipad landscape mode
                body.style.overflow = '';
                setModalWidth('calc(100% - 124px)');
                setModalHeight('calc(100% - 50px)');
            } else if (window.innerWidth > sizes.largeDevice) {
                //for Desktop and Tablet
                setModalWidth('calc(100% - 122px)');
                setModalHeight('calc(100% - 46px)');
            }
            //following background color is added for the Mobile view in calendar page only.
            if (window.innerWidth <= sizes.mobileDevice) {
                let body = document.getElementById('body');
                body.style.backgroundColor = '#140f4b';
            }
            return () => {
                let body = document.getElementById('body');
                body.style.backgroundColor = '';
                body.style.overflow = '';
            };
        }
    }, [innerWidth, bannerInfo]);

    const showFiltersResultsPanel = () => {
        if (displayFilters.length > 0) {
            return true;
        }

        if (selectedViewFilter) {
            if (selectedViewFilter !== 'all') {
                return true;
            }
        } else {
            if (defaultCalendarViewId !== 'all') {
                return true;
            }
        }
        if (!orderCondition) {
            return true;
        }
        return false;
    };

    useEffectWithErrorLogging(() => {
        if (displayFilters.length > 0) {
            dispatch(setShowFiltersResultsPanel(true));
            return;
        }
        if (!displayOrderCondition) {
            dispatch(setShowFiltersResultsPanel(true));
            return;
        }

        if (selectedViewFilter) {
            if (selectedViewFilter !== 'all') {
                dispatch(setShowFiltersResultsPanel(true));
                return;
            }
        } else {
            if (defaultCalendarViewId !== 'all') {
                dispatch(setShowFiltersResultsPanel(true));
                return;
            }
        }
        dispatch(setShowFiltersResultsPanel(false));
    }, [
        defaultCalendarViewId,
        selectedViewFilter,
        displayFilters,
        displayOrderCondition,
    ]);

    let conditionalFilterPanel =
        searchParam?.length > 0
            ? ''
            : showFiltersResultsPanel() && (
                  <ActionsPanel orderCondition={orderCondition} />
              );
    // selectedViewFilter === 'all' ||
    // defaultCalendarViewId === 'all' ||
    // displayFilters?.length > 0 ? (
    //     (selectedViewFilter && selectedViewFilter !== 'all') ||
    //     displayFilters?.length > 0 ? (
    //         <ActionsPanel />
    //     ) : (
    //         ``
    //     )
    // ) : (
    //     <ActionsPanel />
    // );

    const openDetailsModal = () => {
        let body = document.getElementById('body');
        body.style.overflow = '';
        setIsModalVisible(false);
    };

    const validateApplyButton = () => {
        let validateApply =
            convertDateToISOString(new Date(OrderListStartDate), 'start') &&
            listViewEndDate
                ? convertDateToISOString(
                      new Date(OrderListStartDate),
                      'start'
                  ) !== calendarListStartDate ||
                  convertDateToISOString(listViewEndDate, 'end') !==
                      calendarListEndDate
                    ? false
                    : true
                : false;
        return validateApply;
    };

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    const [searchValue, setSearchValue] = useState(searchParam || '');
    useEffectWithErrorLogging(() => {
        setSearchValue(searchParam || '');
    }, [searchParam]);

    // Handler for search input change
    const handleSearchChange = (e) => {
        e == ''
            ? setSearchValue(e)
            : setSearchValue(e.target.value.slice(0, 12));
    };

    // Handler for search input key down
    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (searchValue.trim().length > 0) {
                //hide calendar for mobile device only.
                if (window.innerWidth <= sizes.mobileDevice) {
                    const calendarWrapper = document.getElementsByClassName('calender-wrapper')?.[0];
                    if (calendarWrapper) {
                        calendarWrapper.style.display = 'none';
                    }
                }
                dispatch(setSearchParam(searchValue.trim()));
                dispatch(
                    getSearchCardData({ searchParam: searchValue.trim() })
                );
                document.activeElement.blur();
                openModal();
            }
        }
    };

    // Handler for clearing search
    const handleClearSearch = () => {
        setSearchValue('');
    };

    // Handler for blur
    const handleBlur = () => {
        if (isMobileDevice() && bannerHeight && bannerHeight !== '') {
            window.scrollTo(0, 0);
        }
    };

    
    function handleClearClick() {
        const allView = appliedFilters.basicFilters?.find(
            (filter) => filter.name === 'All'
        );
        const allViewId = allView ? allView.id : '';
        
        dispatch(setSelectedCalendarView(allView || {}));
        dispatch(
            setFilters({
                filterParam: allViewId,
                filterByPhysician: [],
                filterByOrderStatus: [],
                orderType: [],
                filterByAccounts: [],
                filterByProcedure: [],
            })
        );
        dispatch(
            putFilterOptions({
                fields: 'DEFAULT',
                calendarSelection: allViewId,
                filteredOrderTypes: '',
                filteredAccounts: '',
                filteredOrderStatuses: '',
                filteredPhysicians: '',
                filteredProcedures: '',
                assignedFlag: true,
            })
        );
    }

    useDynatracePageName(pageNames.calendar);

    return (
         
        <>
            {settingsLoading ? (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner
                        id="home-home-home-settingsLoadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                    ></Spinner>
                </Backdrop>
            ) : (
                <HomePageContainer>
                    <HeaderContainer>
                        <CalendarPanel openModal={() => openModal(true)} />
                    </HeaderContainer>
                    {(() => {
                        switch (calendarView) {
                            case 'Month':
                                return (
                                    <MainContainer>
                                        <CalendarContainer>
                                            <Calendar />
                                        </CalendarContainer>
                                        <OrderContainer
                                            bannerMargin={bannerHeight}
                                        >
                                            {conditionalFilterPanel}
                                            <OrdersCardView
                                                maxHeight={'20vh'}
                                                openSearchModal={openModal}
                                                isFiterPanelExits={
                                                    conditionalFilterPanel !==
                                                        '' &&
                                                    showFiltersResultsPanel()
                                                }
                                            />
                                        </OrderContainer>
                                    </MainContainer>
                                );
                            case 'Week':
                                return (
                                    <MainContainer>
                                        <WeekMobileViewContainer>
                                            <CalendarContainer>
                                                <Calendar />
                                            </CalendarContainer>
                                            <OrderContainer>
                                                {conditionalFilterPanel}
                                                <OrdersCardView
                                                    maxHeight={'30vh'}
                                                    openSearchModal={openModal}
                                                    isFiterPanelExits={
                                                        conditionalFilterPanel !==
                                                            '' &&
                                                        showFiltersResultsPanel()
                                                    }
                                                />
                                            </OrderContainer>
                                        </WeekMobileViewContainer>
                                        <WeekDesktopContainer>
                                            {/* {selectedViewFilter === 'all' ||
                                defaultCalendarViewId === 'all' ||
                                displayFilters?.length > 0 ? (
                                    (selectedViewFilter &&
                                        selectedViewFilter !== 'all') ||
                                    displayFilters?.length > 0 ? (
                                        <ActionsPanel margin="10px"></ActionsPanel>
                                    ) : (
                                        ``
                                    )
                                ) : (
                                    <ActionsPanel margin="10px"></ActionsPanel>
                                )} */}
                                            {showFiltersResultsPanel() && (
                                                <ActionsPanel
                                                    margin="10px"
                                                    orderCondition={
                                                        orderCondition
                                                    }
                                                ></ActionsPanel>
                                            )}
                                            {window.innerWidth >
                                                sizes.mobileDevice && (
                                                <Timeline
                                                    openSearchModal={openModal}
                                                />
                                            )}
                                        </WeekDesktopContainer>
                                    </MainContainer>
                                );
                            case 'List':
                                return (
                                    <>
                                        {/* {selectedViewFilter === 'all' ||
                            defaultCalendarViewId === 'all' ||
                            displayFilters?.length > 0 ? (
                                (selectedViewFilter &&
                                    selectedViewFilter !== 'all') ||
                                displayFilters?.length > 0 ? (
                                    <>
                                        <FilterResultsPanel
                                            borderTopLeftRadiusStyle={'0px'}
                                            borderTopRightRadiusStyle={
                                                '0px'
                                            }
                                            minHeightStyle={'40px'}
                                            boxShadowStyle={
                                                '0px 3px 6px 0 #e2e2e2'
                                            }
                                            borderRadiusStyle={'5px'}
                                            flexBasisStyle={'20%'}
                                            {...props}
                                            calendarView={calendarView}
                                        />
                                    </>
                                ) : (
                                    <></>
                                )
                            ) : (
                                <FilterResultsPanel
                                    borderTopLeftRadiusStyle={'0px'}
                                    borderTopRightRadiusStyle={'0px'}
                                    minHeightStyle={'40px'}
                                    boxShadowStyle={'0px 3px 6px 0 #e2e2e2'}
                                    borderRadiusStyle={'5px'}
                                    flexBasisStyle={'20%'}
                                    {...props}
                                    calendarView={calendarView}
                                />
                            )} */}
                                        <ActionsPanel
                                            isCaledarListView={true}
                                            isApplyEnabled={() =>
                                                validateApplyButton()
                                            }
                                            setOrderListStartDate={
                                                setOrderListStartDate
                                            }
                                        ></ActionsPanel>
                                        {showFiltersResultsPanel() && (
                                            <FilterResultsPanel
                                                borderTopLeftRadiusStyle={'0px'}
                                                borderTopRightRadiusStyle={
                                                    '0px'
                                                }
                                                minHeightStyle={'40px'}
                                                // boxShadowStyle={
                                                //     '0px 3px 6px 0 #e2e2e2'//?
                                                // }
                                                // borderRadiusStyle={'5px'}
                                                flexBasisStyle={'20%'}
                                                {...props}
                                                calendarView={calendarView}
                                                orderCondition={orderCondition}//?
                                                clearFilterHandler = {handleClearClick}
                                                widthStyle = {'80%'}
                                                mobileWidthStyle = {'100%'}
                                            />
                                        )}
                                        <OrdersListView
                                            openSearchModal={openModal}
                                            OrderListStartDate={
                                                OrderListStartDate
                                            }
                                        />
                                    </>
                                );

                            default:
                                break;
                        }
                    })()}
                    {isModalVisible ? (
                        <ModalContainer>
                            <Modal
                                modalWidth={modalWidth}
                                modalHeight={modalHeight}
                                showBackdrop={isModalVisible}
                                closeModal={closeModal}
                                padding={'22px 36px 22px 22px'}
                                left="0"
                                right="0"
                                bottom="0"
                            >
                                <SearchBox
                                    id="home-calendar-popup-searchbox"
                                    isPopUp={true}
                                    isActiveSearch={false}
                                    openModal={openModal}
                                    updateSearch={handleSearchChange}
                                    searchProduct={searchValue}
                                    placeholder={t(
                                        'calendar.calendarPanel.searchBox.placeholder'
                                    )}
                                    width={
                                        window.innerWidth <= sizes.smalDevice
                                            ? '250px'
                                            : window.innerWidth <= sizes.mediumDevice ? '305px' : '358px'
                                    }
                                    marginDesktop={'0'}
                                    height={'40px'}
                                    borderRadius={'25px'}
                                    paddingLeft={'1.8rem'}
                                    borderLeft={'none'}
                                    paddingRight={'10px'}
                                    isSearchIcon={true}
                                    searchIconWidth={'min-content'}
                                    margin={'0px'}
                                    fontSize={'16px'}
                                    placeHolderFontFamily={'AvenirNextWorld Regular'}
                                    placeholderPaddingLeft={'8px'}
                                    iconColor={'#140F4B'}
                                    fontWeight={'bold'}
                                    handleKeyPress={handleSearchKeyDown}
                                    onBlur={handleBlur}
                                    clearSearch={handleClearSearch}
                                    background={'none'}
                                    enterkeyhint={'go'}
                                    iconPaddingLeft={'0px'}
                                />
                                {!searchCardDataLoading ? (
                                    <>
                                        {searchParam !== '' && (
                                            <>
                                                <SearchResultsPanel
                                                    margin={'13px 0'}
                                                    marginTop={'13px'}
                                                />
                                                <hr
                                                    style={{
                                                        margin: '0',
                                                        borderTop:
                                                            '1px solid #707070',
                                                        opacity: 0.21,
                                                    }}
                                                />
                                            </>
                                        )}

                                        <OrdersContainer>
                                            <OrdersSearchResults
                                                openDetailsModal={
                                                    openDetailsModal
                                                }
                                                searchOrdersResult={
                                                    searchCardData
                                                }
                                            />
                                            <ExtraSpace></ExtraSpace>
                                        </OrdersContainer>
                                    </>
                                ) : (
                                    <Spinner
                                        id="home-home-home-loadingSpinner"
                                        animation="border"
                                        variant="primary"
                                        small
                                    ></Spinner>
                                )}
                            </Modal>
                        </ModalContainer>
                    ) : null}
                    {isDeletePopup ? (
                        <DeleteOrderPopup
                            deleteOrderHandler={deleteOrderHandler}
                            onDeleteClose={deleteCloseHandler}
                            isOtherUser={isOtherUser}
                        />
                    ) : null}
                    {summaryLoading ||
                    deleteLoading ||
                    updateSurgeryLoading ||
                    (isCancelWithoutReason && cancelUsageInProgress) ? (
                        <Backdrop
                            showCloseButton={false}
                            showBackdrop={true}
                            isModal
                            loaderBackground
                        >
                            <Spinner
                                id="home-home-home-globalLoadingSpinner"
                                animation="border"
                                variant="primary"
                                small
                            ></Spinner>
                        </Backdrop>
                    ) : null}
                    {cancelSurgeryData &&
                        Object.keys(cancelSurgeryData).length > 0 &&
                        (showNoUsageToReportPopup ||
                            showCancelSurgeryPopup ||
                            viewProcedureScreen ||
                            showUnidPostponePopup ||
                            showCaseCancelOrPostpone) && (
                            <NoUsageToReportContainer
                                cancelSurgeryData={cancelSurgeryData}
                                showNoUsageToReportPopup={
                                    showNoUsageToReportPopup
                                }
                                showCancelSurgeryPopup={showCancelSurgeryPopup}
                                viewProcedureScreen={viewProcedureScreen}
                                showUnidPostponePopup={showUnidPostponePopup}
                                showCaseCancelOrPostpone={
                                    showCaseCancelOrPostpone
                                }
                            />
                        )}
                    {showContactLogisticsPopup && (
                        <WarningModal
                         id="home-contact-logistics-warning-modal"
                            noWarningImg
                            title={t('calendar.preventShipping')}
                            message={t('calendar.cancellationOrders')}
                            onClose={() =>
                                dispatch({
                                    type: SET_SHOW_CONTACT_LOGISTICS_POPUP,
                                    payload: false,
                                })
                            }
                            webHeight={'70px'}
                            modalContentWidth={'380px'}
                            modalContentHeight={'120px'}
                            titleWidth={'285px'}
                            titleWebWidth={'370px'}
                            titleColor={isLanguageChanged && '#ED002A'}
                            messageColor={isLanguageChanged && '#ED002A'}
                        />
                    )}
                </HomePageContainer>
            )}
        </>
         
    );
};

export default Home;

export const HomePageContainer = styled.div`
    display: flex;
    justify-content: space-around;
    flex-direction: column;

    ${media.portraitDevice`
        flex-direction: column;
        justify-content: space-evenly;
    `}

    ${media.mobileDevice`
        display: block;
        margin: 0;
    `}
`;

export const HeaderContainer = styled.div`
    ${media.mobileDevice`
        display:flex;
        justify-content: center;
        background-color: ${(props) =>
            props.theme.calendarBackgroundColor} !important;
    `}
`;

export const MainContainer = styled.div`
    display: flex;
    margin: 0px 0 10px 0;
    flex-direction: ${isMobile && 'column'};

    ${media.portraitDevice`
        flex-direction: column;
        justify-content: space-evenly;
    `}

    ${media.mobileDevice`
        display: block;
        margin: -1px 0 0 0;
    `}
`;

export const ModalContainer = styled.div`
    ${media.mobileDevice`
        display: none;
    `}
`;

export const OrdersContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    /* height: 100%; */
    height: calc(100vh - 11rem);
    ${scrollBarStyle}
    ${media.mobileDevice`
        background: #f5f5f5;
    `}

    ${media.mediumDevice`
        height: 100%;
    `}

    ${media.smalDevice`
        height: calc(100vh - 10rem);
    `}

${media.mobileDevice`
    height:auto;
    margin: 0;
`}
`;

export const WeekMobileViewContainer = styled.div`
    display: none;

    ${media.mobileDevice`
            display: block;
    `}
`;

export const WeekDesktopContainer = styled.div`
    display: block;
    width: 100%;
    ${media.mobileDevice`
            display: none;
    `};
`;

export const CalendarContainer = styled.div`
    margin: 0 10px 0 0;
    width: ${isMobile ? '100%' : ''};
    justify-content: ${isMobile && 'center'};
    ${media.largeDevice`
        width: ${isMobile ? '100%' : ''};
        display: flex;
        justify-content: center;
        margin: 0 10px 0 0;
    `}
    ${media.mediumDevice`
        width: ${isMobile ? '100%' : '40%'};
        justify-content: ${isMobile && 'center'};
    `} 
    ${media.portraitDevice`
        width: 50%;
        display: flex;
        justify-content: ${isMobile ? 'center' : 'flex-start'};
        margin: 0 0 10px 0;
    `}
   
    ${media.mobileDevice`
        width: 100%;
        display: block;
        margin: 0;
    `};
`;

export const OrderContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${isMobile ? '100%' : '725px'};
    margin: ${isMobile ? '10px 0 0 0' : '0 0 0 10px'};
    height: ${({ bannerMargin }) =>
        bannerMargin
            ? `calc(100vh - 9rem - ${bannerMargin})`
            : 'calc(100vh - 9rem)'};

    ${media.largeDevice`
        max-width: ${isMobile ? '100%' : '65%'};
        display: flex;
        justify-content: center;
        margin: ${isMobile ? '10px 0 0 0' : '0 0 0 10px'};
    `}

    ${media.mediumDevice`
        max-width: ${isMobile ? '100%' : '58%'};
        height: 100%;
    `}
    ${media.portraitDevice`
        min-width: 100%;
        display: flex;
        justify-content: flex-start;
        margin: 10px 0 0 0;
        height: calc(100vh - 34rem);
    `}
    

    ${media.mobileDevice`
        max-width: 95%;
        height:auto;
        margin: 0;
    `}
`;
export const ExtraSpace = styled.div`
    padding-top: 8%;
    @media (min-width: 1920px) and (max-width: 2560px) {
        padding-top: 5%;
    }

    ${media.largeDevice`
          padding-top: 8%;
    `}
    ${media.mediumDevice`
         padding-top: 15%;
    `}
     ${media.smalDevice`
         padding-top: 15%;
    `}
     ${media.mobileDevice`
         padding-top: 15%;
    `};
`;
